(function($) {
"use strict";

/*------------------------------------------------------------------
[Table of contents]



-------------------------------------------------------------------*/

/*--------------------------------------------------------------
CUSTOM PRE DEFINE FUNCTION
------------------------------------------------------------*/
/* is_exist() */
jQuery.fn.is_exist = function(){
  return this.length;
}


$(function(){

    /*--------------------------------------------------------------
OS MENU JS
--------------------------------------------------------------*/

$(".menu-bar").on("click", function () {
    $(".offcanves-menu, .offcanvas-overlay").addClass("active");
});
$(".close, .offcanvas-overlay").on("click", function () {
    $(".offcanves-menu, .offcanvas-overlay").removeClass("active");
});

    /*--------------------------------------------------------------
OS CONTENT READ LESS JS INIT
--------------------------------------------------------------*/

//  $('.see-more').on("click", function(e) {
//     e.preventDefault();
//    $('.moretext').slideToggle();
//    if ($('.see-more').text() == "Less more") {
//      $(this).text("Read more")
//    } else {
//      $(this).text("Less more")
//    }
//  });
 

     // Configure/customize these variables.    
	$('.prevent-default').click(function(e){
		e.preventDefault();
	});
	
    $('.more').each(function() {
		if(50 < $(this).find(".content").height()){
			$(this).parent().find(".dots").toggleClass("hide");
			$(this).parent().find(".morelink").toggleClass("hide");
			$(this).parent().find(".spacer").remove();
		}
    });
 
    $(".morelink").click(function(){
        $(this).parent().find(".more").toggleClass("all");
		$(this).parent().find(".dots").toggleClass("hide");
		$(this).parent().find(".lesslink").toggleClass("hide");
		$(this).parent().find(".spacer").addClass("hide");
		
		$(this).toggleClass("hide");
    });
	
	$(".lesslink").click(function(){
        $(this).parent().find(".more").toggleClass("all");
		$(this).parent().find(".dots").toggleClass("hide");
		$(this).parent().find(".morelink").toggleClass("hide");
		$(this).parent().find(".spacer").removeClass("hide");
		
		$(this).toggleClass("hide");
    });
	

/*--------------------------------------------------------------
OS STICKY MENU JS INIT
--------------------------------------------------------------*/
// $(window).on('scroll', function(){
//   if ($(window).scrollTop() > 50) {
//       $('#sticky-menu').addClass('sticky-menu');
//   } else {
//       $('#sticky-menu').removeClass('sticky-menu');
//   }

// });




/*--------------------------------------------------------------
THEPAW YOUTUBE MAGNIFIC POPUP JS
------------------------------------------------------------*/
// var popup_youtube = $('.popup-video');
//   if (popup_youtube.is_exist()){
//       popup_youtube.magnificPopup({
//       type: 'iframe',
//       mainClass: 'mfp-fade'
//   });

// }


/*--------------------------------------------------------------
THEPAW PROJECT SLIDER JS
--------------------------------------------------------------*/
var slider_init = $('.slider-init');
  if (slider_init.is_exist()) {
      slider_init.owlCarousel({
      loop:true,
      margin: 45,
      center: true,
      nav:false,
      dots:false,
      autoplay:true,
    //   animateOut: 'fadeOut',
    //   animateIn: 'fadeIn',
      autoHeight:true,
      items:3,
      responsive:{
          0:{
              items:1
          },
          600:{
              items:3
          },
          768:{
              items:3
          },
          1000:{
              items:3
          }
      }

  });

}

/*--------------------------------------------------------------
THEPAW PROJECT SLIDER JS
--------------------------------------------------------------*/
var hero_slider = $('.hero-slider-init');
  if (hero_slider.is_exist()) {
      hero_slider.owlCarousel({
      loop:true,
      margin: 0,
      nav:false,
      dots:true,
      animateOut: 'fadeOut',
      animateIn: 'fadeIn',
    //   autoHeight:true,
    autoplay: true,
      items:1,

  });

}


/*--------------------------------------------------------------
LP EXTRA MENU INIT
--------------------------------------------------------------*/

if ($('a.click-btn').length > 0) {
	$('a.click-btn').on('click', function(e) {
		e.preventDefault();
		$('html, body').animate({ scrollTop: $($(this).attr('href')).offset().top}, 700, 'linear');
	});
}
if ($('a.scroll-to-btn').length > 0) {
	$('a.scroll-to-btn').on('click', function(e) {
		e.preventDefault();
		$('html, body').animate({ scrollTop: $($(this).attr('href')).offset().top}, 700, 'linear');
	});
}

/*--------------------------------------------------------------
COOKIES
--------------------------------------------------------------*/

if(localStorage.getItem('cookiesAccepted') == null){
	$(".cookies-section").removeClass("hide");
}else{
	$(".cookies-section").addClass("hide");
}

$(".cookies-btn").unbind("click");
$(".cookies-btn").bind("click",function(e){
	$.ajax({
	  type: "POST",
	  url: "/api/cookies/accept",
	  data: {Accept: true},
	  success: function(data){
		  if(JSON.parse(data).message.toLowerCase() == 'true'){
			localStorage.setItem('cookiesAccepted', "true");
			$(".cookies-section").hide("400");  
		  }else{
			$(".cookies-section").show("400");   
		  }
	  }
	});
	
	e.preventDefault();
});

/*--------------------------------------------------------------
CV INPUT
--------------------------------------------------------------*/
if($(".cv-input").length > 0){
	$(".cv-input").on('change', function(){
	  var fileChosen = $(this).parent().find(".cv-chosen");
	  fileChosen.html(this.files[0].name);
	})
}

/*--------------------------------------------------------------
FAQ
--------------------------------------------------------------*/

$(".question").click(function(){
	$(this).parent().find(".answer").slideToggle();
	$(this).parent().find(".question img").toggleClass("up");
});

/*--------------------------------------------------------------
FORM VALIDATION
--------------------------------------------------------------*/
$("input[name='key']").each(function() {
  $(this).val($(this).attr("key"));
});
$("form").submit(function(e){
	if(!$(this).find(".privacy-disclaimer").is(':checked')){
	  $(this).find(".alert").removeClass("hide");
	  e.preventDefault();
	}
});

});/*End document ready*/


$(window).on("resize", function(){

}); // end window resize


$(window).on("load" ,function(){








}); // End window LODE

/*WOW ANIMATION*/

  var wow = new WOW({
      mobile: false,       // default
      tablet:false
    });
    wow.init();


    //  SCROLLING FIXED NEXT SECTION BTN
    $(window).on('scroll', function() {
		if($('.hero-section').offset() != undefined){
		 if ($(window).scrollTop() >= $('.hero-section').offset().top + $('.hero-section').outerHeight() - window.innerHeight) {
            $('.click-btn').removeClass('fixed')
         }else{
            $('.click-btn').addClass('fixed')
         }
		}
    });




})(jQuery);









